import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const NameServerIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M15.65.05c-1.15,0-2.23.45-3.04,1.26L1.05,12.86-.05,20.05l7.18-1.09,11.56-11.56c.81-.81,1.26-1.89,1.26-3.04s-.45-2.23-1.26-3.04c-.81-.81-1.89-1.26-3.04-1.26ZM12.33,3.6l1.53,1.53L4.26,14.73l-1.53-1.53L12.33,3.6ZM1.66,18.34l.55-3.64,3.08,3.08-3.64.55ZM6.79,17.27l-1.53-1.53L14.87,6.14l1.53,1.53-9.6,9.6ZM17.69,6.38l-.28.28-4.07-4.07.28-.28c.54-.54,1.26-.84,2.04-.84s1.49.3,2.03.84c.54.54.84,1.26.84,2.03s-.3,1.49-.84,2.04Z" />
 </svg>,
 "NameServer"
);
